import { render, staticRenderFns } from "./thongbao.vue?vue&type=template&id=3cc9a8de&scoped=true&"
import script from "./thongbao.vue?vue&type=script&lang=js&"
export * from "./thongbao.vue?vue&type=script&lang=js&"
import style0 from "./thongbao.vue?vue&type=style&index=0&id=3cc9a8de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc9a8de",
  null
  
)

export default component.exports